import { Configuration, configDimUnit } from "./core/configuration";
import { dimCentiMeter } from "./core/constants";
import { Model } from "./model/model";
import { Viewer, floorplannerModes } from "./view/Viewer";
import { ConfigurationHelper } from "./helpers/ConfigurationHelper";
import { FloorPlannerHelper } from "./helpers/FloorplannerHelper";

class FloorPlannerController {
  /**
   * Creates an instance of FloorPlannerController. This is the entry point for the application
   */
  constructor(options) {
    Configuration.setValue(configDimUnit, dimCentiMeter);

    /**
     * @property {Object} options
     * @type {Object}
     **/
    this.options = options;
    /**
     * @property {Model} model
     * @type {Model}
     **/
    this.model = new Model();

    this.configurationHelper = new ConfigurationHelper();
    this.floorplanningHelper = null;

    if (!options.widget) {
      /**
       * @property {Viewer} floorplanner
       * @type {Viewer}
       **/
      let viewer2dOptions = this.options.viewer2d.viewer2dOptions || {};
      viewer2dOptions.resize = this.options.resize ? true : false;
      this.floorplanner = new Viewer(
        options.viewer2d.id,
        this.model.floorplan,
        viewer2dOptions,
      );
      this.floorplanningHelper = new FloorPlannerHelper(
        this.model.floorplan,
        this.floorplanner,
      );
    }

    this.view_now = 2;
    document.getElementById(this.options.viewer2d.id).style.visibility =
      "visible";
  }

  setViewerModeToDraw(mode) {
    this.floorplanner.switchMode(floorplannerModes.DRAW);
    this.floorplanner.__drawArrow = false;
    if (mode) {
      this.floorplanner.__drawArrow = true;
    }
  }

  setViewerModeToMove(mode) {
    this.floorplanner.switchMode(floorplannerModes.MOVE);
    this.floorplanner.__changeCursorMode();
  }

  switchViewerToTransform(mode) {
    this.floorplanner.switchMode(floorplannerModes.EDIT_ISLANDS);
  }

  getImageData() {
    return this.floorplanner.getImageData();
  }

  getImageData1() {
    return this.floorplanner.getImageData1();
  }

  getCurrentFloorplanMode() {
    return this.floorplanner.__mode;
  }

  insertIcons(icon) {
    this.floorplanner.insertIcons(icon);
  }

  insertLabels(label) {
    this.floorplanner.insertLabels(label);
  }

  setFontSize(size) {
    this.floorplanner.setFontSize(size);
  }
}
export { FloorPlannerController };
